import styled from "styled-components";

export const DocContainer = styled.div`
  max-height: 600px;
  overflow-y: auto;
`;
